import React, {Component} from 'react';
import {Bar, Line, Doughnut} from 'react-chartjs-2';
import { isEmpty } from 'lodash'
import Currency from '../../commonModules/Currency';
import { TableLayout } from './Stock/containers/Layout';
import { TableBody, TableRow, TableCell, Box, Paper, Card, Grid, Typography } from '@material-ui/core';
import { Fragment } from 'react';
import { MiniCard, MiniPaper } from '../../commonModules/layouts/CardPage';
import HighChart from '../../commonModules/interface/Charts/HighChart';
import HighChartDouble from '../../commonModules/interface/Charts/HighChartDouble';
import HighChartLine from '../../commonModules/interface/Charts/HighChartLine';
import { BarChartRounded, DonutLargeRounded, GraphicEqRounded, TimelineRounded } from '@material-ui/icons';

const Months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre']

const sortByDate = (list) => {
    list.sort((a, b) => {
        a = new Date(a);
        b = new Date(b);
        if (a > b){
            return 1;
        }
        if (a < b) {
            return -1;
        }
        return 0;
    });
    return list
} 

const getLabels = (date_list) => {
    let new_date_list = []
    date_list.map(date => {
        let label = Months[new Date(date).getMonth()] +" "+ new Date(date).getFullYear()
        if(!new_date_list.includes(label)){
            new_date_list.push(label)
        }
    })
    // console.log({new_date_list});
    return new_date_list
}

const calcAveragePayment = (userInfo, nbPeriods) => {
    let average_payment_period = userInfo.periodicity || 0
    let average_payment_amount = (userInfo.totalPayed - userInfo.initialPayment) / (nbPeriods -1) || 0
        
    // console.log({
    //     average_payment_amount,
    //     nbPeriods,
    //     average_payment_period,
    // });
    return {
        average_payment_amount,
        nbPeriods,
        average_payment_period,
    }
}

export const calcData = (userInfo, paymentList, abo) => {
    const cumulPaymentPrev = []
    const cumulPaymentReal = []
    const cumulPaymentAverage = []
  
    const previsional_data = []
    const real_payment_data = []
    const average_payment_data = []
    
    const bckg_real_data = []
    const bckg_previsional_data = []
    const bckg_average_data = []
    
    const prev_payment_object = {} // {"octobre 2018": 16000, septembre:16000}
    const real_payment_object = {} // {"octobre 2018": 16000, septembre:16000}
    const average_payment_object = {} // {"octobre 2018": 16000, septembre:16000}
    
    let dateLabels = [] // [... "octobre 2018", "septembre 2018"]
    let totalAmountLate = 0
    let prevPast = userInfo.initialPayment || 0
    let previsions = [userInfo.initialPayment] // for credit score
  
    const periodicityTS = (userInfo.periodicity || 31) * 24 * 60 * 60 * 1000 // period entre chaque paiement en millisecondes TS
    const first_payment_date = new Date(paymentList[0].timePayment)
    const amountAbo = userInfo.totalToPay - userInfo.initialPayment
    const mensualite = abo ? abo.mensualite : 1
    const prev_nb_payments = amountAbo / mensualite //!\ next payment === 0 when fully paid
    // const prev_nb_payments = amountAbo / userInfo.nextPaymentAmount //!\ next payment === 0 when fully paid
    const length_abo_daysTS = prev_nb_payments * periodicityTS

    const abo_endTS = first_payment_date.getTime() + length_abo_daysTS
    const label_end_month = new Date(abo_endTS).getMonth()
    const label_end_year = new Date(abo_endTS).getFullYear() // last prev date

    const label_today_month = new Date().getMonth()
    const label_today_year = new Date().getFullYear()

    const period_since_start = ( Date.now() - first_payment_date.getTime()) / periodicityTS
    // const period_since_start = ( Date.now() - first_payment_date)/1000/60/60/24/ (userInfo.periodicity || 31)

    const average = calcAveragePayment(userInfo, period_since_start)

    let payment_dates = paymentList.map( pay => {
        let label_payment = Months[new Date(pay.timePayment).getMonth()] +" "+ new Date(pay.timePayment).getFullYear() // "Octobre 2018"
        
        real_payment_object[label_payment] = (real_payment_object[label_payment] || 0) + pay.money // si plusieurs paiements ce mois ci
        // prev_payment_object[label_payment] = 0
        return pay.timePayment
    })
    
    // get echeances dates and label for prev data
    for (let index = 0; index <= Math.ceil( prev_nb_payments ); index++ ) { 

        let echeance_paiementTS = first_payment_date.getTime() + periodicityTS * index // date paiement dû  TS
        let echeance_paiement_month = Months[new Date(echeance_paiementTS).getMonth()] // MOIS paiement dû
        let label_echeance = echeance_paiement_month +" "+ new Date(echeance_paiementTS).getFullYear() // mois + année paiement dû
    
        // prev_payment_object[label_echeance] = userInfo.nextPaymentAmount
        if (
            new Date(echeance_paiementTS).getFullYear() < label_end_year || 
            ( 
                (new Date(echeance_paiementTS).getFullYear() === label_end_year) &&
                (new Date(echeance_paiementTS).getMonth() <= label_end_month)
            ) 
        ) {
            prev_payment_object[label_echeance] = mensualite
            // prev_payment_object[label_echeance] = userInfo.nextPaymentAmount
        }

        if (index !== 0 ){
            if (
                new Date(echeance_paiementTS).getFullYear() < label_today_year || 
                ( 
                    (new Date(echeance_paiementTS).getFullYear() === label_today_year) &&
                    (new Date(echeance_paiementTS).getMonth() <= label_today_month)
                ) 
            ) {
                prevPast += mensualite // total prevision at today's date : somme sensée être payée à ce jour
                previsions.push(mensualite) // total prevision at today's date : somme sensée être payée à ce jour
            }
        }

        average_payment_object[label_echeance] = average.average_payment_amount
        
        payment_dates.push(echeance_paiementTS)
    }  
    
    dateLabels = getLabels(sortByDate(payment_dates))
      
    dateLabels.map((date, i) => {
        bckg_real_data.push('rgba(255, 206, 86, 0.6)')// chart color
        bckg_previsional_data.push('rgba(54, 162, 235, 0.6)')// chart color
        bckg_average_data.push('rgba(230, 60, 134, 0.6)')// chart color
    
        let initialPayment =  userInfo.initialPayment  || 0 // initial payment !== periodicity payment 
        let prev_amount = prev_payment_object[date] || 0 // montant dû ce mois ou 0 pour periodes sans paiement /!\ must stop at end abo date
        let payed_amount = real_payment_object[date] || 0 // montant payé ce mois ou 0 pour periodes sans paiement
        let average_amount = average_payment_object[date] || 0 // montant moyen  des paiements user
          
        real_payment_data[i] = payed_amount

        if (i === 0){
            cumulPaymentReal[i] = payed_amount
            
            previsional_data[i] = initialPayment
            cumulPaymentPrev[i] = initialPayment 
            
            average_payment_data[i] = 0
            cumulPaymentAverage[i] = initialPayment
        } else {
            cumulPaymentReal[i] = payed_amount+ cumulPaymentReal[i-1]
            
            previsional_data[i] = prev_amount 
            cumulPaymentPrev[i] = prev_amount + cumulPaymentPrev[i-1]

            average_payment_data[i] = average_amount 
            cumulPaymentAverage[i] = average_amount + cumulPaymentAverage[i-1]
        }
    })
    
    let totalDiff = prevPast - cumulPaymentReal[cumulPaymentReal.length -1]
    totalAmountLate = totalDiff > 0 ? totalDiff : 0

    // console.log({
    //     first_payment_date, 
    //     period_since_start, 
    //     dateLabels, 
    //     real_payment_object, 
    //     prev_payment_object,
    //     real_payment_data,
    //     previsional_data,
    //     cumulPaymentPrev, 
    //     cumulPaymentReal, 
    //     totalAmountLate,
    //     prevPast
    // });     
          
    // series: [{
    //     name: 'Employees',
    //     color: 'rgba(165,170,217,1)',
    //     data: [150, 73, 20],
    //     pointPadding: 0.3,
    // }, {
    //     name: 'Employees Optimized',
    //     color: 'rgba(126,86,134,.9)',
    //     data: [140, 90, 40],
    //     pointPadding: 0.4,
    
    // }]

    return[
        // restToPay:,
        totalAmountLate,
        average.average_payment_amount,
        {
            labels: dateLabels,
            series:[
                {
                    name:'Prévision',
                    data: previsional_data,
                    pointPadding: 0,
                    color: 'rgba(54, 162, 235, 0.6)'// chart color
                },
                {
                    name: 'Réel',
                    data:real_payment_data,
                    pointPadding: 0.3,
                    color: 'rgba(255, 206, 86, 0.8)'// chart color
                },
            ]
        },{
            labels: dateLabels,
            series:[
                {
                    name: 'Prévision',
                    data: cumulPaymentPrev,
                    pointPadding: 0,
                    color: 'rgba(54, 162, 235, 0.6)'// chart color
                },
                {
                    name: 'Réel',
                    data: cumulPaymentReal,
                    pointPadding: 0.3,
                    color: 'rgba(255, 206, 86, 0.6)'// chart color
                },
            ]
        },
        real_payment_data,
        previsions
    ]
}
  
const calcPaymentFrequency = (userInfo, paymentList) => {
    let nbPayment = paymentList.length - 1 // - 1st payment
    let average_payment_amount = (userInfo.totalPayed - userInfo.initialPayment) / nbPayment || 0
    let secondPayment = Date.now()
    if (typeof paymentList[1] !== "undefined") {
        secondPayment = new Date(paymentList[1].timePayment)
    }
    
    let average_payment_period = ( Date.now() - secondPayment) / 1000 / 60 / 60 / 24 / nbPayment || 0
    
    // console.log({
    //     average_payment_amount,
    //     nbPayment,
    //     average_payment_period,
    // });
    return {
        average_payment_amount,
        nbPayment,
        average_payment_period,
    }
}

export class BarChart extends Component{
   state = {
        chartData: this.props.chartData
    }
    
    static defaultProps = {
        displayTitle:true,
        displayLegend: true,
        legendPosition:'right',
    }
  
    render(){
        let data = calcData(this.props.userInfo, this.props.paymentList, this.props.abo)[2]
            
        return (
            <MiniPaper
                title={this.props.title}
                subtitle={" "}
                avatar={<BarChartRounded color="secondary" />}
            >
                <Box p={1}>
                    <HighChartDouble
                        // title={this.props.title}
                        titleY="Montant FCFA"
                        type="column"
                        categories={data.labels}
                        series={data.series}
                        // colors={data.bckg}
                        // disableLegend={true}
                    />
                </Box>
            </MiniPaper>
        )
    }
}
export class LineChart extends Component{
    state = {
        chartData:this.props.chartData
    }
  
    static defaultProps = {
        displayTitle:true,
        displayLegend: true,
        legendPosition:'right',
    }
    render(){
        // console.log("LINE CHART ",this.props);
        
        let data = calcData(this.props.userInfo, this.props.paymentList, this.props.abo)

        if(this.props.totalLate){
            this.props.totalLate(data[0])
        }
        return (
            <MiniPaper
                title={this.props.title}
                subtitle={" "}
                avatar={<TimelineRounded color="secondary" />}
            >
                <Box p={1}>  
                    <HighChartLine 
                        // title={this.props.title}
                        titleY="Montant FCFA"
                        type="column"
                        categories={data[3].labels}
                        series={data[3].series}
                        // colors={data.bckg}
                        // disableLegend={true}
                    />
                </Box>
            </MiniPaper>
        )
    }
}
export class DoughnutChart extends Component{
    state = {
        chartData:this.props.chartData
    }
  
    static defaultProps = {
        displayTitle:true,
        displayLegend: true,
        legendPosition:'right',
    }
  
    render(){
        // console.log("CHARTS PROPS", this.props);
        const { totalToPay, totalPayed } = this.props.userInfo
        let lateAmount = calcData(this.props.userInfo, this.props.paymentList, this.props.abo)[0]
        lateAmount = lateAmount > 0 ? lateAmount : 0

        const payedPer = (Math.round( (totalPayed / totalToPay) * 10000) / 100)
        const latePaymentPer = (Math.round( (lateAmount / totalToPay) * 10000) / 100)
        let rest = totalToPay - totalPayed - lateAmount
        let restToPayPer = (Math.round((100 - payedPer - latePaymentPer) * 100) / 100)
        if (rest < 0) {
            rest = 0
        }
        if (restToPayPer < 0) {
            restToPayPer = 0
        }
        const data = {
            labels: [ 
              `${new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 }).format(totalPayed)} Remboursé`,
              `${new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 }).format(lateAmount)} En Retard`, 
              `${new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 }).format(rest)} Échéances futures`
            ],
            datasets:[
            {
                label:'Etat Paygo',
                data:[
                    payedPer ,
                    latePaymentPer,
                    // late,
                    restToPayPer, 
                ],
                backgroundColor:[
                  'rgba(255, 206, 86, 0.6)',
                  // 'rgba(54, 162, 235, 0.6)',
                  'rgba(255, 0, 0, 0.6)',
                  'rgba(75, 192, 192, 0.6)',
                  // 'rgba(255, 99, 132, 0.6)',
                //   'rgba(153, 102, 255, 0.6)',
                //   'rgba(255, 159, 64, 0.6)',
                //   'rgba(255, 99, 132, 0.6)',
                ],
            }
            ]
        }
        if(this.props.totalLate){
            this.props.totalLate(lateAmount)
        }
        return (
            <MiniPaper
                title={this.props.title}
                subtitle={<Currency value={(totalToPay - totalPayed)} prefix="Reste à payer "/>}
                avatar={<DonutLargeRounded color="secondary" />}
            >
                <Box p={1}>
                    <Doughnut
                        data={data}
                        options={{
                            plugins: {
                                title: {
                                    display: this.props.displayTitle,
                                    text: this.props.title,
                                    //   padding: {
                                    //     top: 10,
                                    //     bottom: 0
                                    // }
                                },
                                legend:{
                                    display:this.props.displayLegend,
                                    position:this.props.legendPosition
                                }
                            }}
                        }
                    />
                </Box>
            </MiniPaper>
        )
    }
}
export class ProgressChart extends Component{
  
    render(){
        const { userInfo, paymentsIDList, paymentList, reportsIDList, REPORTS, abo } = this.props
        const user_payment_frequency = calcPaymentFrequency(userInfo, paymentList)
        const data = calcData(userInfo, paymentList, this.props.abo)
        const averagePayment = data[1]
        // console.log({averagePayment, userInfo});
        
        let abo_start = 0
        let amountAbo = 0
        let nb_payments = 0
        let todayTS = 0
        let abo_startTS = 0
        let length_abo_days = 0
        let days_since_start = 0
        let abo_endTS = 0
        let elapsed_percentage = 0
      
        if(paymentsIDList.length > 0){ 
            amountAbo = userInfo.totalToPay - userInfo.initialPayment
            nb_payments = amountAbo / userInfo.nextPaymentAmount
            todayTS = Date.now()
            abo_start = new Date(paymentList[0].timePayment)
            abo_startTS = new Date(paymentList[0].timePayment).getTime()
    
            length_abo_days = nb_payments * userInfo.periodicity
            abo_endTS = abo_startTS + (length_abo_days * 1000 * 60 * 60 * 24)
            days_since_start = ((todayTS - abo_startTS) / 1000 / 60 / 60 / 24)
            elapsed_percentage = ((days_since_start / length_abo_days * 100) > 100 ) ? 100 : (days_since_start / length_abo_days * 100)
        }
  
        let nb_reports = 0
        let unsolved_reports = 0
    
        if(reportsIDList.length > 0){
            nb_reports = reportsIDList.length 
            reportsIDList.forEach(reportID => {
                let reportStatus = REPORTS[reportID].labels
                let lastStatus = reportStatus[reportStatus.length -1].val
                if(lastStatus !== "Résolu"){
                    unsolved_reports += 1
                }
            });
        }
  
        // console.log({
        //     paymentsIDList,
        //     abo_start,
        //     amountAbo,
        //     nb_payments,
        //     todayTS,
        //     abo_startTS,
        //     abo_endTS,
        //     length_abo_days,
        //     days_since_start,
        //     elapsed_percentage,
        //     nb_reports,
        //     unsolved_reports
        // });
        // console.log("PROGRESS CHARTS PROPS", this.props, this.state);
        
        return (
            <MiniPaper
                title={"Progression Abonnement"}
                subtitle={" "}
                avatar={<GraphicEqRounded color="secondary" />}
            >
                <Box>
                    <p>
                        {/* <h5>Progression Abonnement</h5> */}
                        <div style={{display:"flex", justifyContent:"space-between"}}>
                            <span>Début</span>
                            <span>Fin</span>
                        </div>
        
                        <div className="progress-max">
                            <div className="progress-value" style={{ width:`${elapsed_percentage}%`}}></div>
                        </div> 
                    </p>
                    <TableLayout>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ fontWeight: "700"}} >Client depuis le</TableCell>
                                <TableCell>{new Date(abo_start).toLocaleDateString('fr-FR')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ fontWeight: "700"}} >Fin d'abonnement prévue </TableCell>
                                <TableCell>{new Date(abo_endTS).toLocaleDateString('fr-FR')} ({Math.round(length_abo_days - days_since_start)} Jours)</TableCell>
                            </TableRow>
                            {/* <TableRow>
                                <TableCell style={{ fontWeight: "700"}} >Type Abonnement</TableCell>
                                <TableCell>{this.props.abo.name} - <Currency value={this.props.abo.total} /></TableCell>
                            </TableRow> */}
                            {abo.type === 'Day' &&
                                <Fragment>
                                    {/* <TableRow>
                                        <TableCell style={{ fontWeight: "700"}} >Mensualité Abonnement</TableCell>
                                        <TableCell><Currency 
                                            value={Math.round(this.props.abo.mensualite / userInfo.periodicity * 31) } 
                                            suffix=" " /> 
                                        </TableCell>
                                    </TableRow> */}
                                    <TableRow>
                                        <TableCell style={{ fontWeight: "700"}} >Fréquence de Paiement Moyenne</TableCell>
                                        <TableCell>
                                            <b><Currency 
                                            value={Math.round(user_payment_frequency.average_payment_amount) } 
                                            suffix=" " /> </b>  tous les <b>{Math.round(user_payment_frequency.average_payment_period)}</b> jours</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: "700"}} >Paiement Moyen</TableCell>
                                        <TableCell>
                                            <b><Currency 
                                            value={Math.round(averagePayment) } 
                                            suffix=" " /> </b> tous les <b>{Math.round(userInfo.periodicity)}</b> jours</TableCell>
                                    </TableRow>

                                </Fragment>
                            }
                            <TableRow>
                                <TableCell style={{ fontWeight: "700"}} >Nombre de Pannes</TableCell>
                                <TableCell>{nb_reports} <small><i>(dont non Résolues: {unsolved_reports})</i></small> </TableCell>
                            </TableRow>
                        </TableBody>
                    </TableLayout>
                </Box>
            </MiniPaper>
        )
    }
}
 